<template>
  <div
    v-if="data"
    class="mission-page"
  >
    <header class="mission-header">
      <button
        type="button"
        class="header-btn"
        @click="$router.push('/user')"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ data.title }}</h1>
      <span class="header-spacer" />
    </header>

    <nav class="status-tabs">
      <button
        v-for="tab in statusTabs"
        :key="tab.route"
        type="button"
        class="status-tab"
        :class="{ active: tab.active }"
        @click="$router.push(tab.route)"
      >
        {{ tab.label }}
      </button>
    </nav>

    <main class="mission-content">
      <section
        class="round-hero"
        :style="heroStyle"
      >
        <div class="issue-card">
          <div class="issue-label">
            {{ $t('buyMission.currentSponsorshipRound') }}
          </div>
          <div class="issue-number">
            [{{ periodCode() }}]
          </div>
        </div>

        <van-count-down
          class="countdown-wrap"
          :time="data && data.time ? data.time * 1000 : 0"
          @finish="finish"
        >
          <template #default="timeData">
            <div class="countdown-boxes">
              <span
                v-for="(part, partIndex) in countdownParts(timeData)"
                :key="partIndex"
                class="countdown-box"
              >{{ part }}</span>
            </div>
          </template>
        </van-count-down>
      </section>

      <section
        v-if="posterImages.length"
        class="poster-grid"
      >
        <div
          v-for="(image, posterIndex) in posterImages"
          :key="posterIndex"
          class="poster-frame"
        >
          <img
            :src="image"
            alt=""
            @error="onPosterError"
          >
        </div>
      </section>

      <section class="boost-section">
        <h2>{{ $t('buyMission.managerReservation') }}</h2>
        <div class="boost-grid">
          <button
            v-for="option in boostOptions"
            :key="option.key"
            type="button"
            class="boost-option"
            :class="{ checked: option.selected }"
            :style="{ backgroundImage: 'url(' + option.image + ')' }"
            @click="toggleOption(option.key)"
          >
            <span>{{ option.label }}</span>
            <span
              v-if="option.selected"
              class="option-check"
            >
              <van-icon name="success" />
            </span>
          </button>
        </div>
      </section>
    </main>

    <div class="buy-panel">
      <div class="amount-row">
        <label for="missionAmount">{{ $t('ihome.invite') }}</label>
        <input
          id="missionAmount"
          v-model.trim="num"
          type="number"
          min="1"
          step="1000"
          class="amount-input"
          :placeholder="$t('pro2.enteramount')"
        >
        <strong>{{ selectedMoney() }}  {{ $t('shopd.total') }}</strong>
      </div>
      <button
        type="button"
        class="buy-submit"
        :class="{ disabled: submitting }"
        :disabled="submitting"
        @click="buy"
      >
        {{ $t('buyMission.confirmSubmit') }}
      </button>
    </div>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('pro2.loading')"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import {
		Overlay,
		Circle,
		Dialog,
		CountDown,
		Icon,
		Toast
	} from 'vant';

	Vue.use(Overlay)
		.use(Circle)
		.use(Dialog)
		.use(CountDown)
		.use(Icon)
		.use(Toast);

	export default {
		name: "Buy",
		data() {
			return {
				show1: false,
				submitting: false,
				currentRate: 0,
				gradientColor: {
					'0%': '#7a63ff',
					'100%': '#ff7b32'
				},
				data: null,
				index: 0,
				acc: null,
				num: '',
				da: 0,
				xiao: 0,
				dan: 0,
				shuang: 0,
				kai: null,
				items: null,
				kais: null
			};
		},
		computed: {
			statusTabs() {
				return [{
					label: this.$t('pro.processing'),
					route: '/order',
					active: true
				}, {
					label: this.$t('pro2.succ'),
					route: '/order',
					active: false
				}, {
					label: this.$t('pro2.fail'),
					route: '/order',
					active: false
				}, {
					label: this.$t('pro.all'),
					route: '/order',
					active: false
				}];
			},
			heroStyle() {
				var image = this.normalizeImage(this.data && this.data.baner);
				if (!image) {
					return {};
				}
				return {
					backgroundImage: 'url(' + image + ')'
				};
			},
			posterImages() {
				var images = [];
				if (!this.data) {
					return images;
				}
				for (var i = 1; i <= 9; i++) {
					var image = this.normalizeImage(this.data['p' + i]);
					if (image) {
						images.push(image);
					}
				}
				return images;
			},
			boostOptions() {
				return [{
					key: 'da',
					label: this.optionLabel('sda', 'rose'),
					image: require('../images/ban6/p1.jpg'),
					selected: this.da == 1
				}, {
					key: 'xiao',
					label: this.optionLabel('sxiao', 'lily'),
					image: require('../images/ban6/p2.jpg'),
					selected: this.xiao == 1
				}, {
					key: 'dan',
					label: this.optionLabel('sdan', 'fireworks'),
					image: require('../images/ban6/p3.jpg'),
					selected: this.dan == 1
				}, {
					key: 'shuang',
					label: this.optionLabel('sshuang', 'balloon'),
					image: require('../images/ban6/p4.jpg'),
					selected: this.shuang == 1
				}];
			}
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.index = this.$router.history.current.params.code;
			this.start();
			this.accinfo();
		},
		methods: {
			periodCode() {
				return this.data && this.data.qi ? this.data.qi : "";
			},
			normalizeImage(image) {
				if (!image) {
					return '';
				}
				image = String(image).trim();
				if (!image) {
					return '';
				}
				if (image.indexOf('//') === 0) {
					return 'https:' + image;
				}
				return image;
			},
			optionLabel(field, fallbackKey) {
				var label = this.data && this.data[field] ? String(this.data[field]).trim() : '';
				return label || this.$t('buyMission.' + fallbackKey);
			},
			padTime(value) {
				value = parseInt(value, 10);
				if (isNaN(value) || value < 0) {
					value = 0;
				}
				return value < 10 ? '0' + value : String(value);
			},
			countdownParts(timeData) {
				var hours = Number(timeData.days || 0) * 24 + Number(timeData.hours || 0);
				return [
					this.padTime(hours),
					this.padTime(timeData.minutes),
					this.padTime(timeData.seconds)
				];
			},
			toggleOption(key) {
				this[key] = this[key] == 1 ? 0 : 1;
			},
			selectedCount() {
				return Number(this.da) + Number(this.xiao) + Number(this.dan) + Number(this.shuang);
			},
			selectedMoney() {
				var money = parseFloat(this.num);
				if (isNaN(money) || money < 0) {
					money = 0;
				}
				return this.selectedCount() * money;
			},
			onPosterError(event) {
				if (event && event.target) {
					event.target.style.visibility = 'hidden';
				}
			},
			graptime(randomInt) {
				this.currentRate += randomInt;
				if (this.currentRate < 100) {
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				} else {
					this.show1 = false;
					this.start();
					this.accinfo();
				}
			},
			finish() {
				this.show1 = true;
				var randomInt = Math.floor(Math.random() * 20) + 10;
				this.currentRate = 0;
				this.graptime(randomInt);
			},
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			start() {
				Fetch('/index/item_detail', {
					id: this.index
				}).then(res => {
					this.data = res.data;
					this.vip = res.data.vip;
					this.kais = res.data.kais;
					if (this.kais) {
						this.kai = this.kais[0];
					}
				});
				Fetch('/index/itemslist').then(res => {
					this.items = res.data;
				});
			},
			buy() {
				if (this.submitting) {
					return false;
				}
				var amount = this.da + this.xiao + this.dan + this.shuang;
				var money = parseFloat(this.num);
				if (amount == 0) {
					this.$toast(this.$t('pro.seltype'));
					return false;
				}
				if (isNaN(money) || money < 1) {
					this.$toast(this.$t('pro.minmoney0'));
					return false;
				}
				amount = amount * money;
				if (this.acc && amount > Number(this.acc.money || 0)) {
					this.$toast(this.$t('pro.insufficient'));
					return false;
				}
				Dialog.confirm({
					title: '',
					confirmButtonText: this.$t('utils.confirm'),
					cancelButtonText: this.$t('utils.cancel'),
					message: this.$t('pro.issubmit')
				}).then(() => {
					this.submitting = true;
					Fetch("/user/item_buy", {
						id: this.data.id,
						money: this.num,
						da: this.da,
						xiao: this.xiao,
						dan: this.dan,
						shuang: this.shuang
					}).then(r => {
						if (r.data && r.data > 0) {
							this.$router.push("/invest");
						} else {
							this.$router.push("/order");
						}
					}).catch(err => {
						console.log(err);
					}).then(() => {
						this.submitting = false;
					});
				}).catch(() => {});
				return true;
			}
		}
	};
</script>

<style lang="less" scoped>
	.mission-page {
		min-height: 100vh;
		overflow-x: hidden;
		background: #282239;
		color: #fff;
		box-sizing: border-box;
		padding-bottom: 28px;
		font-family: Arial, "Helvetica Neue", sans-serif;
	}

	.mission-header {
		position: sticky;
		top: 0;
		z-index: 20;
		height: 50px;
		display: grid;
		grid-template-columns: 54px minmax(0, 1fr) 54px;
		align-items: center;
		background: linear-gradient(90deg, #6879e8 0%, #7b46a8 100%);
		box-sizing: border-box;
	}

	.mission-header h1 {
		margin: 0;
		color: #fff;
		font-size: 14px;
		font-weight: 800;
		line-height: 22px;
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.header-btn,
	.status-tab,
	.boost-option,
	.buy-submit {
		border: 0;
		outline: none;
		-webkit-tap-highlight-color: transparent;
	}

	.header-btn {
		width: 100%;
		height: 100%;
		padding: 0;
		background: transparent;
		color: #fff;
		font-size: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.header-spacer {
		display: block;
	}

	.status-tabs {
		position: sticky;
		top: 50px;
		z-index: 19;
		height: 50px;
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		align-items: stretch;
		background: linear-gradient(180deg, #5874e1 0%, #8347a8 100%);
		box-shadow: 0 8px 18px rgba(23, 16, 45, .32);
	}

	.status-tab {
		position: relative;
		min-width: 0;
		padding: 0 4px;
		background: transparent;
		color: rgba(255, 255, 255, .86);
		font-size: 12px;
		font-weight: 700;
		line-height: 24px;
		text-align: center;
	}

	.status-tab.active {
		color: #ffe500;
	}

	.status-tab.active:after {
		content: "";
		position: absolute;
		left: 22%;
		right: 22%;
		bottom: 12px;
		height: 2px;
		border-radius: 999px;
		background: #ff8b00;
		box-shadow: 0 0 0 1px rgba(255, 246, 95, .72);
	}

	.mission-content {
		padding: 0 16px 24px;
		box-sizing: border-box;
	}

	.round-hero {
		position: relative;
		min-height: 288px;
		margin: 0 -16px;
		padding: 0 16px;
		background:
			linear-gradient(180deg, rgba(56, 41, 82, .22) 0%, rgba(40, 34, 57, .12) 58%, #282239 100%),
			linear-gradient(135deg, #73d7c0 0%, #f65865 100%);
		background-size: cover;
		background-position: center;
		box-sizing: border-box;
	}

	.round-hero:after {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 76px;
		background: linear-gradient(180deg, rgba(40, 34, 57, 0) 0%, #282239 100%);
		pointer-events: none;
	}

	.issue-card {
		position: relative;
		z-index: 2;
		top: 0;
		margin: 0 -4px;
		padding: 12px 10px 15px;
		border-radius: 0 0 7px 7px;
		background: rgba(13, 13, 15, .96);
		box-shadow: 0 8px 18px rgba(0, 0, 0, .5);
		text-align: center;
		box-sizing: border-box;
	}

	.issue-label {
		min-height: 24px;
		color: #f8f8f8;
		font-size: 14px;
		font-weight: 800;
		line-height: 24px;
		text-shadow: 0 2px 2px rgba(0, 0, 0, .9);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.issue-number {
		margin-top: 4px;
		padding: 9px 8px 8px;
		border-radius: 5px;
		background: #202020;
		color: #ffea00;
		font-size: 14px;
		font-weight: 900;
		line-height: 24px;
		letter-spacing: 0;
		box-shadow: inset 0 1px 1px rgba(255, 255, 255, .09);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.countdown-wrap {
		position: absolute;
		z-index: 3;
		left: 0;
		right: 0;
		bottom: 36px;
	}

	.countdown-boxes {
		display: grid;
		grid-template-columns: repeat(3, 104px);
		justify-content: space-around;
		align-items: center;
		padding: 0 61px;
		box-sizing: border-box;
	}

	.countdown-box {
		width: 80px;
		height: 80px;
		border: 8px solid #ff8a00;
		border-radius: 14px;
		background: #fff;
		color: #f77d00;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		font-size: 30px;
		font-weight: 400;
		line-height: 1;
	}

	.poster-grid {
		position: relative;
		// z-index: 4;
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 12px;
		margin-top: 20px;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.poster-frame {
		aspect-ratio: 1 / 1.08;
		border: 5px solid #fff;
		background: #151322;
		box-sizing: border-box;
		overflow: hidden;
	}

	.poster-frame img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.boost-section {
		margin-top: 35px;
		margin-bottom: 26px;
	}

	.boost-section h2 {
		margin: 0 6px 28px;
		color: #fff;
		font-size: 14px;
		font-weight: 900;
		line-height: 31px;
	}

	.boost-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px 24px;
		padding: 0 6px;
		box-sizing: border-box;
	}

	.boost-option {
		position: relative;
		min-width: 0;
		height: 55px;
		padding: 0 7px 0 55px;
		border-radius: 9px;
		background-color: #7c26da;
		background-size: cover;
		background-position: center;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
		overflow: visible;
		text-align: right;
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .3);
	}

	.boost-option span:not(.option-check) {
		position: relative;
		z-index: 1;
		min-width: 0;
		max-width: none;
		display: block;
		color: #fff;
		font-size: 12px;
		font-weight: 900;
		line-height: 24px;
		text-shadow: 0 2px 3px rgba(0, 0, 0, .65);
		white-space: nowrap;
		overflow: visible;
		text-overflow: clip;
	}

	.boost-option.checked {
		box-shadow:
			0 0 0 2px rgba(255, 242, 0, .9),
			0 0 14px rgba(255, 242, 0, .82),
			inset 0 1px 0 rgba(255, 255, 255, .3);
	}

	.boost-option.checked span:not(.option-check) {
		color: #f8ff00;
		font-size: 14px;
	}

	.option-check {
		position: absolute;
		z-index: 2;
		top: -11px;
		right: -9px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: #ff725d;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, .24);
	}

	.buy-panel {
		position: relative;
		z-index: 3;
		width: calc(100% - 20px);
		max-width: 580px;
		margin: 0 auto;
		padding: 0 0 18px;
		background: transparent;
		box-sizing: border-box;
	}

	.amount-row {
		height: 84px;
		padding: 9px 14px;
		border-radius: 8px;
		background: #313131;
		display: grid;
		grid-template-columns: minmax(80px, auto) minmax(0, 1fr) auto;
		align-items: center;
		column-gap: 10px;
		box-sizing: border-box;
		box-shadow: 0 16px 30px rgba(0, 0, 0, .24);
	}

	.amount-row label {
		min-width: 0;
		color: #f3f3f3;
		font-size: 12px;
		font-weight: 800;
		line-height: 20px;
	}

	.amount-input {
		width: 150px;
		height: 50px;
		padding: 0 10px;
		border: 2px solid rgba(255, 255, 255, .12);
		border-radius: 6px;
		background: #4a4a4a;
		box-sizing: border-box;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		outline: none;
		text-align: left;
	}

	.amount-input::placeholder {
		color: rgba(255, 255, 255, .33);
	}

	.amount-row strong {
		color: #ff6269;
		font-size: 14px;
		font-weight: 900;
		line-height: 28px;
		white-space: nowrap;
	}

	.buy-submit {
		display: block;
		width: calc(100% - 20px);
		height: 55px;
		margin: 20px auto 0;
		border-radius: 15px;
		background: linear-gradient(90deg, #ff6467 0%, #ff5621 100%);
		color: #fff;
		font-size: 14px;
		font-weight: 900;
		line-height: 30px;
		box-shadow: 0 14px 26px rgba(255, 87, 42, .24);
	}

	.buy-submit.disabled {
		opacity: .65;
	}

	.wrapper1 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
	}

	.block {
		width: 140px;
		height: 140px;
		padding: 14px;
		border-radius: 18px;
		background: #282239;
		box-shadow: 0 18px 40px rgba(0, 0, 0, .42);
		box-sizing: border-box;
	}

	/deep/ .van-overlay {
		background-color: rgba(0, 0, 0, .72);
	}

	/deep/ .van-circle__text {
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}

	@media (max-width: 420px) {
		.mission-header {
			height: 55px;
			grid-template-columns: 48px minmax(0, 1fr) 48px;
		}

		.mission-header h1 {
			font-size: 14px;
		}

		.status-tabs {
			top: 55px;
			height: 72px;
		}

		.status-tab {
			font-size: 14px;
		}

		.round-hero {
			min-height: 274px;
		}

		.issue-label {
			font-size: 14px;
		}

		.issue-number {
			font-size: 16px;
		}

		.countdown-boxes {
			grid-template-columns: repeat(3, 96px);
			padding: 0 40px;
		}

		.countdown-box {
			width: 96px;
			height: 96px;
			border-width: 7px;
			font-size: 46px;
		}

		.poster-grid {
			gap: 10px;
			padding: 0 10px;
		}

		.poster-frame {
			border-width: 4px;
		}

		.boost-section h2 {
			font-size: 16px;
		}

		.boost-grid {
			gap: 12px 22px;
		}

		.boost-option {
			padding-left: 72px;
		}

		.boost-option span:not(.option-check) {
			font-size: 14px;
		}

		.amount-row {
			grid-template-columns: minmax(118px, auto) minmax(0, 1fr) auto;
			column-gap: 10px;
		}

		.amount-row label,
		.amount-row strong {
			font-size: 16px;
		}

		.amount-input {
			height: 64px;
			font-size: 14px;
		}
	}

	@media (max-width: 360px) {
		.mission-page {
			padding-bottom: 24px;
		}

		.mission-content {
			padding-right: 12px;
			padding-left: 12px;
		}

		.round-hero {
			min-height: 248px;
			margin-right: -12px;
			margin-left: -12px;
			padding-right: 12px;
			padding-left: 12px;
		}

		.issue-card {
			margin-right: 0;
			margin-left: 0;
		}

		.issue-label {
			font-size: 12px;
		}

		.issue-number {
			font-size: 14px;
		}

		.countdown-boxes {
			grid-template-columns: repeat(3, 82px);
			padding: 0 30px;
		}

		.countdown-box {
			width: 82px;
			height: 82px;
			border-width: 6px;
			border-radius: 12px;
			font-size: 38px;
		}

		.poster-grid {
			gap: 8px;
			padding: 0 8px;
		}

		.poster-frame {
			border-width: 3px;
		}

		.boost-section {
			margin-top: 28px;
		}

		.boost-section h2 {
			margin-bottom: 20px;
			font-size: 16px;
		}

		.boost-grid {
			gap: 10px 14px;
		}

		.boost-option {
			height: 62px;
			padding: 0 10px 0 58px;
		}

		.boost-option span:not(.option-check) {
			font-size: 14px;
			line-height: 20px;
		}

		.buy-panel {
			width: calc(100% - 16px);
			padding-bottom: 14px;
		}

		.amount-row {
			height: 74px;
			padding: 8px 10px;
			grid-template-columns: minmax(112px, auto) minmax(0, 1fr) auto;
			column-gap: 8px;
		}

		.amount-row label,
		.amount-row strong {
			font-size: 14px;
			line-height: 24px;
		}

		.amount-input {
			height: 56px;
			padding: 0 8px;
			font-size: 14px;
		}

		.buy-submit {
			height: 66px;
			margin-top: 14px;
			border-radius: 18px;
			font-size: 16px;
		}
	}
</style>
